const MM_TO_PX = 96 / 25.4

export function mmToPx (mm) {
  return (Number(mm) || 0) * MM_TO_PX
}

export function getPhysicalPaperPx (page) {
  const { w, h } = getPhysicalPaperMm(page)
  return {
    w: Math.round(mmToPx(w)),
    h: Math.round(mmToPx(h))
  }
}

/** 纸张物理尺寸（mm），含横向 */
export function getPhysicalPaperMm (page) {
  const p = page || {}
  let w
  let h
  if (String(p.paperSize || '').toLowerCase() === 'custom') {
    w = Number(p.customWidthMm) || 50
    h = Number(p.customHeightMm) || 30
  } else if (p.paperSize === 'A3') {
    w = 297
    h = 420
  } else if (p.paperSize === 'Letter') {
    w = 216
    h = 279
  } else {
    w = 210
    h = 297
  }
  if (p.orientation === 'landscape') {
    const t = w
    w = h
    h = t
  }
  return { w, h }
}

export function getInnerPrintableSizePx (page) {
  const { w, h } = getPhysicalPaperMm(page)
  const p = page || {}
  const mt = p.marginTop ?? 10
  const mb = p.marginBottom ?? 10
  const ml = p.marginLeft ?? 10
  const mr = p.marginRight ?? 10
  const iw = mmToPx(Math.max(0, w - ml - mr))
  const ih = mmToPx(Math.max(0, h - mt - mb))
  return { w: Math.max(1, iw), h: Math.max(1, ih) }
}

/** @page size：自定义用 mm；标准纸用名称 + orientation */
export function buildAtPageSizeCss (page) {
  const p = page || {}
  const ori = p.orientation === 'landscape' ? 'landscape' : 'portrait'
  if (String(p.paperSize || '').toLowerCase() === 'custom') {
    let w = Number(p.customWidthMm)
    let h = Number(p.customHeightMm)
    if (!Number.isFinite(w) || w < 1) w = 50
    if (!Number.isFinite(h) || h < 1) h = 30
    if (ori === 'landscape') {
      const t = w
      w = h
      h = t
    }
    return `${w}mm ${h}mm`
  }
  const name = p.paperSize || 'A4'
  return `${name} ${ori}`
}
